import { render, staticRenderFns } from "./NewCandidateDashboard.vue?vue&type=template&id=26c9eaf1&scoped=true"
import script from "./NewCandidateDashboard.vue?vue&type=script&lang=js"
export * from "./NewCandidateDashboard.vue?vue&type=script&lang=js"
import style0 from "./NewCandidateDashboard.vue?vue&type=style&index=0&id=26c9eaf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c9eaf1",
  null
  
)

export default component.exports